/**
 * Vibrant Portal (va-portal) access control.
 *
 * Sales-role internal users aren't allowed into va-portal at all — va-portal's own
 * ChoosePortalLogin.vue hides the VW Portal button and auto-redirects them straight to
 * Unimod. Mirror that restriction here so the Switch Platform menu doesn't offer a
 * destination they'd immediately get bounced from.
 */
export function isVaPortalAccessAllowed(userInfo) {
  return userInfo?.internal_role !== "sales";
}
